import { render, staticRenderFns } from "./MakeRemark.vue?vue&type=template&id=07f22002&scoped=true&"
import script from "./MakeRemark.vue?vue&type=script&lang=js&"
export * from "./MakeRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f22002",
  null
  
)

export default component.exports